import { SortOrder } from "./types";

export const getNextSortType = (order?: SortOrder): SortOrder | undefined => {
  return order === undefined ? SortOrder.ASC : order === SortOrder.ASC ? SortOrder.DES : undefined;
};
